export const nameCardDef = {
  name: "Name",
  translation: "OC_NAME",
  type: "name",
  children: [
    {
      label: "Prefix name",
      translation: "MY_HR_PREFIX_NAME",
      value: "prefixName",
    },
    {
      label: "Last name",
      translation: "MY_HR_LAST_NAME",
      value: "lastName",
    },
    {
      label: "First name",
      translation: "MY_HR_FIRST_NAME",
      value: "firstName",
    },
    {
      label: "Middle name",
      translation: "MY_HR_MIDDLE_NAME",
      value: "middleName",
    },
    {
      label: "Name suffix",
      translation: "MY_HR_NAME_SUFFIX",
      value: "nameSuffix",
    },
  ],
};

export const birthCardDef = {
  label: "Birth card",
  translation: "MY_HR_BIRTH_CARD_TITLE",
  children: [
    {
      label: "Date of birth",
      translation: "MY_HR_DATE_OF_BIRTH",
      value: "dateOfBirth",
      type: "dateOfBirth",
    },
    {
      label: "Country of birth",
      translation: "MY_HR_COUNTRY_OF_BIRTH",
      value: "countryOfBirth",
      type: "countryOfBirth",
    },
    {
      label: "Place of birth",
      translation: "MY_HR_PLACE_OF_BIRTH",
      value: "placeOfBirth",
      type: "placeOfBirth",
    },
    {
      label: "Mother's name",
      translation: "MY_HR_MOTHERS_NAME",
      value: "mothersName",
      type: "mothersName",
    },
    {
      label: "Gender",
      translation: "MY_HR_GENDER",
      value: "gender",
      type: "gender",
    },
    {
      label: "Marital status",
      translation: "MY_HR_MARITAL_STATUS",
      value: "maritalStatus",
      type: "maritalStatus",
    },
  ],
};

export const codeCardDef = {
  label: "Codes",
  translation: "MY_HR_CODE_CARD_TITLE",
  children: [
    {
      label: "Tax number",
      translation: "MY_HR_TAX_NUMBER",
      value: "taxNumber",
      type: "taxNumber",
    },
    {
      label: "Social security number",
      translation: "MY_HR_SOCIAL_SECURITY_NUMBER",
      value: "socialSecurityNumber",
      type: "socialSecurityNumber",
    },
    {
      label: "Identity card number",
      translation: "MY_HR_IDENTITY_CARD_NUMBER",
      value: "identityCardNumber",
      type: "identityCardNumber",
    },
    {
      label: "Nationality",
      translation: "MY_HR_NATIONALITY",
      value: "nationality",
      type: "nationality",
    },
  ],
};

const address = [
  {
    label: "Nationality",
    translation: "MY_HR_NATIONALITY",
    value: "nationality",
    type: "nationality",
  },
];

export const permanentAddress = {
  label: "Permanent address",
  translation: "MY_HR_PERMANENT_ADDRESS",
  type: "address",
  address: "permanentAddress",
  children: address,
};

export const temporaryAddress = {
  label: "Temporary address",
  translation: "MY_HR_TEMPORARY_ADDRESS",
  type: "address",
  address: "temporaryAddress",
  children: address,
};

export const serviceAddress = {
  label: "Service address",
  translation: "MY_HR_SERVICE_ADDRESS",
  type: "address",
  address: "serviceAddress",
  children: address,
};

export const email = {
  label: "Email",
  translation: "MY_HR_EMAIL",
  type: "email",
};

export const phone = {
  label: "Phone",
  translation: "MY_HR_TELEPHONE",
  type: "phone",
};

export const contract = {
  type: "contract",
  children: [
    {
      label: "Period",
      type: "period",
    },
    {
      label: "Contract type",
      translation: "MY_HR_CONTRACT_TYPE",
      type: "subName",
      value: "typeOfContract",
    },
    {
      label: "Employment type",
      translation: "MY_HR_EMPLOYMENT_TYPE",
      type: "subName",
      value: "employmentType",
    },
    {
      label: "Job class",
      translation: "MY_HR_JOB_CLASS",
      type: "subName",
      value: "jobClass",
    },
    {
      label: "Position",
      translation: "MY_HR_POSITION",
      value: "position",
    },
    {
      type: "divider",
    },
    {
      label: "Company",
      translation: "OC_COMPANY",
      type: "subName",
      value: "company",
    },
    {
      label: "Org unit",
      translation: "OC_ORGUNIT",
      type: "subName",
      value: "orgUnit",
    },
    {
      label: "Working place",
      translation: "OC_WORKINGPLACE",
      type: "subName",
      value: "workingPlace",
    },
    {
      label: "Job class group",
      translation: "OC_JOBCLASSGROUP",
      type: "subName",
      value: "jobClassGroup",
    },
    {
      label: "Payoffice",
      translation: "OC_PAYOFFICE",
      type: "subName",
      value: "payOffice",
    },
    {
      type: "divider",
    },
    {
      label: "Shift type",
      translation: "OC_SHIFT_TYPE",
      type: "subName",
      value: "shiftType",
    },
    {
      label: "Max overtime in hour",
      translation: "MY_TIME_MAX_OVERTIME_IN_HOUR",
      value: "maxOvertimeInHour",
    },
  ],
};

export const addressDefs = [
  phone,
  email,
  permanentAddress,
  temporaryAddress,
  serviceAddress,
];
